import { render, staticRenderFns } from "./select-service-recurrence.vue?vue&type=template&id=3a768d4c"
import script from "./select-service-recurrence.vue?vue&type=script&lang=js"
export * from "./select-service-recurrence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports